import { Spin } from 'antd';
import { Outlet } from 'react-router-dom';

import { useLoading } from '@/contexts/LoadingContext';

export const RootLayout = () => {
  const { isLoading } = useLoading();

  return (
    <Spin
      spinning={isLoading}
      size="large"
      style={{
        maxHeight: '100vh',
      }}
    >
      <Outlet />
    </Spin>
  );
};
